/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import useConfig from "../../../actions/Tenants/config/configHook";
import { useUserPreferences } from "../../../hooks";
import { getFilledArrayOrDefault } from "../../../utils";
import SingleSelect from "../../Forms/SingleSelect";

export default function FacilityFilter() {
    const config = useConfig();
    const [userPreferences, updatePreferences] = useUserPreferences();

    const options = getFilledArrayOrDefault(config.form_options?.facility);

    return (
        <div css={css`
            width: 20rem;
            z-index: 1000;
            @media (max-width: 992px) {
                width: 100%;
                min-width: 15rem;
            }
        `} className="mb-n3">

            <SingleSelect
                options={options.map(({ value, label }) => ({ value, label }))}
                field="facilities"
                setValue={(_, value) => updatePreferences({ facilities: getFilledArrayOrDefault(value as string[]) })}
                post_value={userPreferences.facilities}
                label={false}
                multi={true}
                isClearable={true}
                return_array={true}
                placeholder="Select facilities"
            />
        </div>
    );
}
